var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonLink',_vm._b({staticClass:"l-IconButtonLink",attrs:{"aria-label":_vm.title,"data-test":"link"}},'ButtonLink',_vm.$props,false),[_c('FontIcon',{class:{'mr-sm': _vm.hasSlotContent},attrs:{"data-test":"icon","name":_vm.icon}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }